import React from "react";
import { Box, Typography } from "@mui/material";

export default function ColorDotLabel({
  color,
  label,
  size = 14,      // dot size
  gap = 8         // spacing between dot & label
}) {
  return (
    <Box display="flex" alignItems="center" gap={`${gap}px`}>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: color,
          flexShrink: 0
        }}
      />
      {label && (
        <Typography variant="body2" noWrap>
          {label}
        </Typography>
      )}
    </Box>
  );
}